import React from 'react';
import _UserMenu from './_UserMenu.scss';
import {Link, withRouter} from 'react-router-dom';
import {Menu} from './menu.js';
import {connect} from 'react-redux';
import {logout} from 'base/actions';
import {toastr} from 'react-redux-toastr';
import {ShowIf} from 'components/utils';

class UserMenu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      active: this.props.active
    };
  }

  signout() {
    this.props.history.push('/signin');
    this.props.dispatch(logout()).then(res => {
      toastr.success("Thành công", "Bạn đã đăng xuất thành công");
    });
  }

  checkBussiness() {
    if (this.props.auth && this.props.auth.isAuthenticated && this.props.businesses && !this.props.businesses.mainBusiness) {
      return false
    } else {
      return true
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.businesses !== this.props.businesses) {
      this.forceUpdate();
    }
  }

  render() {
    return (
      <section className="user-menu-left-wrap">
        <div className='user-menu-left'>
          <div className='my-business-wrap'>
            {
              Menu.map((menuItem, i) => {
                let className='my-business-menu-item';
                if (menuItem.subMenu && menuItem.subMenu.length > 0) {
                  className = className + ' has-submenu';
                }

                if (this.state.active == menuItem.active) {
                  className = className + ' is-active';
                }

                return (
                  <div className={className} key={i}>
                    <Link className='my-business-menu-wrap-item' to={menuItem.link}><i className={menuItem.icon}/><span className='my-business-menu-content'>{menuItem.name}</span></Link>
                    {
                      menuItem.subMenu && menuItem.subMenu.length > 0 ? (
                        <div className='my-business-submenu'>
                          <div className='my-business-submenu-shadow'>
                            {
                              menuItem.subMenu.map((subMenu, j) => {
                                return (
                                  <div className='my-business-submenu-item' key={j}>
                                    <Link className='my-business-submenu-item-link' to={subMenu.link ? subMenu.link : ''}><span className='my-business-submenu-content'>{subMenu.name}</span></Link>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      ) : null
                    }
                  </div>
                );
              })
            }
            <ShowIf condition={this.checkBussiness()}>
              <div className='my-business-menu-item'>
                <Link className='my-business-menu-wrap-item' to='/my-business/announcements'><i className={`vtd vtd-thong-tin-doanh-nghiep`}/><span className='my-business-menu-content'>Doanh nghiệp của bạn</span></Link>
              </div>
            </ShowIf>
            <div className='my-business-logout'>
              <p className='my-business-name'><a href='javascript:void(0)' onClick={this.signout.bind(this)}>Đăng xuất</a></p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(connect()(UserMenu));



// WEBPACK FOOTER //
// ./components/layouts/user/menu/UserMenu.jsx